/** @format */

import { EnumSurveyAnswerStatus } from "../../../Common/Enums/EnumsTypes";
import { PercentagePropsTypes, TOnWheel } from "../PercentagePropsTypes";
import "../SCSS/styles.css";

function Percentage({
  isPreview,
  questionId,
  surveyAnswers,
  handleChangeInputNumber,
  surveyAnswersInfo,
  reducerState,
}: PercentagePropsTypes) {
  return (
    <div className="supplier-view-percentage-cover">
      <div className="supplier-view-percentage-lower-limit-cover">
        <input
          id={questionId}
          disabled={
            isPreview ||
            surveyAnswers?.[questionId]?.notApplicableInfo?.isNotApplicable
          }
          type="number"
          className="limits"
          placeholder="Please enter percentage"
          onChange={(e) =>
            surveyAnswersInfo?.surveyStatus !==
              EnumSurveyAnswerStatus?.COMPLETED &&
            !surveyAnswers?.[questionId!]?.notApplicableInfo?.isNotApplicable &&
            handleChangeInputNumber!(questionId, e)
          }
          value={surveyAnswers?.[questionId]?.val ?? ""}
          onWheel={(e: TOnWheel) => e.target.blur()}
        />
      </div>
      {reducerState?.validNumberErrorMessage?.[questionId]?.length! > 0 && (
        <p className="valid-percentage-msg">
          {reducerState?.validNumberErrorMessage?.[questionId]}
        </p>
      )}
      {surveyAnswersInfo.surveyInfo.questionsInfo.questionObj?.[questionId]
        ?.emissionFactor?.enabled &&
        !isPreview && (
          <div className="supplier-view-percentage-emission-factor">{`emission factor is ${surveyAnswersInfo?.surveyInfo?.questionsInfo?.questionObj?.[questionId]?.emissionFactor?.value}`}</div>
        )}
    </div>
  );
}

export default Percentage;
